import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation UpsertSurveyConfiguration(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $input: SpaceSurveyConfigurationInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                upsertSurveyConfiguration(input: $input)
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.always(undefined)

export const executor = graphql.createExecutor<
  graphql.schema.UpsertSurveyConfigurationMutation,
  void,
  graphql.schema.UpsertSurveyConfigurationMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
